module.exports = __webpack_public_path__ + "img/img26.3313251d.svg";